/**
 * @class TutorialManager
 */
export default class TutorialManager {
    /**
     * @param {Object}  tutorial
     * @param {Array}   finished
     * @param {String}  active
     */
    constructor(tutorial, finished, active) {
        let finishedTutorial;
        for (finishedTutorial of finished) {
            if (tutorial[finishedTutorial]) {
                delete tutorial[finishedTutorial];
            }
        }

        this._active = active;
        this._tutorial = tutorial;
    }

    /**
     * @return {String}
     */
    get active() {
        return this._active;
    }

    /**
     * @param   {String}    key
     */
    setActive = (key) => {
        return new TutorialManager(this._tutorial, [], key === null || this._tutorial[key] === undefined ? null : key);
    };

    /**
     * @param   {String}    key
     * @return  {Boolean}
     */
    isActive = (key) => {
        return this._tutorial[key] !== undefined && this._active === key;
    };

    /**
     * @param   {String}    key
     */
    finishTutorial = (key) => {
        delete this._tutorial[key];

        return new TutorialManager(this._tutorial, [], null);
    };

    /**
     * @param   {String}    key
     * @return  {Array}
     */
    getSteps = (key) => {
        if (this._tutorial[key] !== undefined) {
            return this._tutorial[key];
        }

        return [];
    };
}
